// src/pages/Admin.jsx
import { useMemo } from "react";
import {
    FiShield,
    FiSettings,
    FiCalendar,
    FiImage,
    FiBarChart2,
    FiExternalLink,
    FiCheckCircle,
} from "react-icons/fi";

import "../styles/Pengenalan.css";

export default function Admin() {
    const href = useMemo(() => "https://admin.etikaf.com", []);

    const open = () => window.open(href, "_blank", "noopener,noreferrer");

    return (
        <div className="pg-wrap">
            <div className="container pg-container">
                {/* HERO */}
                <div className="pg-hero">
                    <div>
                        <h1 className="pg-h1">Admin Etikaf</h1>

                        <p className="pg-lead">
                            Portal <b>Admin</b> ialah tempat untuk pihak masjid mengurus kandungan dan tetapan —
                            seperti pengumuman, poster/media, jadual, paparan ETV, maklumat masjid, dan laporan.
                            Ia direka untuk memudahkan kerja pengurusan agar maklumat sampai kepada jemaah dengan
                            lebih cepat dan tersusun.
                        </p>

                        <div className="pg-hero-actions">
                            <button className="pg-btn pg-btn-primary" type="button" onClick={open}>
                                <FiExternalLink /> Teruskan ke Admin
                            </button>

                        </div>


                    </div>

                    {/* Right card */}
                    <div className="pg-side-card">
                        <div className="pg-side-head">
                            <div className="pg-side-ic">
                                <FiShield />
                            </div>
                            <div>
                                <div className="pg-side-title">Untuk pihak masjid</div>
                                <div className="pg-side-sub">Akses terhad & terkawal</div>
                            </div>
                        </div>

                        <div className="pg-side-body">
                            <div className="pg-side-mini">
                                <div className="pg-mini-row">
                                    <FiCheckCircle /> Kemas kini kandungan
                                </div>
                                <div className="pg-mini-row">
                                    <FiCheckCircle /> Urus paparan ETV
                                </div>
                                <div className="pg-mini-row">
                                    <FiCheckCircle /> Pantau & semak data
                                </div>
                            </div>

                            <div className="pg-note" style={{ marginTop: 12 }}>
                                Jika anda jemaah, anda tidak perlu masuk portal ini.
                            </div>
                        </div>
                    </div>
                </div>

                {/* Info */}
                <div className="pg-section" id="admin-info">
                    <div className="pg-section-title">
                        <span className="pg-kicker">Overview</span>
                        <h2 className="pg-h2">Apa yang boleh dibuat dalam Admin?</h2>
                        <p className="pg-desc">
                            Antara modul yang biasa digunakan oleh pihak masjid.
                        </p>
                    </div>

                    <div className="pg-grid-3">
                        <div className="pg-card">
                            <div className="pg-card-icon"><FiImage /></div>
                            <div>
                                <div className="pg-card-title">Poster & Media</div>
                                <div className="pg-card-text">
                                    Upload poster, gambar, video dan urus susunan paparan.
                                </div>
                            </div>
                        </div>

                        <div className="pg-card">
                            <div className="pg-card-icon"><FiCalendar /></div>
                            <div>
                                <div className="pg-card-title">Jadual & Aktiviti</div>
                                <div className="pg-card-text">
                                    Kemas kini program, kuliah, ceramah dan pengumuman berkaitan.
                                </div>
                            </div>
                        </div>

                        <div className="pg-card">
                            <div className="pg-card-icon"><FiSettings /></div>
                            <div>
                                <div className="pg-card-title">Tetapan Masjid</div>
                                <div className="pg-card-text">
                                    Kemaskini profil masjid, pautan, nombor telefon dan konfigurasi.
                                </div>
                            </div>
                        </div>

                        <div className="pg-card">
                            <div className="pg-card-icon"><FiBarChart2 /></div>
                            <div>
                                <div className="pg-card-title">Laporan Ringkas</div>
                                <div className="pg-card-text">
                                    Semak ringkasan data/aktiviti mengikut modul yang digunakan.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </div>
        </div>
    );
}
